export default __webpack_public_path__ + "static/media/status_off.29c2565a.svg";